import script from "./esCalendarSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./esCalendarSettings.vue?vue&type=script&setup=true&lang=ts"

import "./esCalendarSettings.vue?vue&type=style&index=0&id=e0a6578c&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0a6578c"]])

export default __exports__